let LifecycleStateFlag = function (props) {
  let lifecycleState = props.lifecycleState || "";

  return /IN_PROGRESS|COMPLETE/.test(lifecycleState) ? (
    <span className="rc-lifecycle-state-flag" data-lifecyclestate={lifecycleState}>
      {tx("lifecycleState." + lifecycleState)}
    </span>
  ) : null;
};

module.exports = LifecycleStateFlag;